import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-map-direction2-icon',
  templateUrl: './map-direction2.component.html'
})
export class MapDirection2Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
